import { all, fork } from "redux-saga/effects";

import { watchEmailVerification } from "../pages/emailVerification/redux/emailVerification.watchers";
import { watchOfwcaPath } from "../pages/ofwcaPath/redux/ofwcaPath.watchers";
import { watchCommon } from "../redux/common/common.sagas";
import { watchAppSettings } from "../appSettings/redux/appSettings.sagas";
import { watchUserContext } from "../userContext/redux/userContext.sagas";
import { watchLesson } from "../lesson/redux/lesson.sagas";
import { sagas } from "../modules";

export default function* rootSaga() {
  yield all([
    fork(watchEmailVerification),
    fork(watchCommon),
    fork(watchAppSettings),
    fork(watchUserContext),
    fork(watchLesson),
    fork(watchOfwcaPath),
    ...sagas.map(fork),
  ]);
}
